(() => {
    const mobileNavigationButton = document.querySelector('[data-mobile-navigation-button]');
    const mobileNavigationOverlay = document.querySelector('[data-mobile-navigation-overlay]');

    if (mobileNavigationButton && mobileNavigationOverlay) {
        mobileNavigationButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.target.blur();

            document.body.classList.toggle('mobile-navigation-overlay-active');
        });
    }
})();
